// // src/Components/DonatePage.jsx
// import React, { useState } from "react";
// import "./DonatePage.css";
// import { db } from "./firebase";
// import { collection, addDoc } from "firebase/firestore";

// const DonatePage = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     transactionId: "",
//     screenshot: null,
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       await addDoc(collection(db, "donations"), {
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//         transactionId: formData.transactionId,
//         timestamp: new Date(),
//       });

//       alert("✅ Thank you! Our team will contact you soon.");
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         transactionId: "",
//         screenshot: null,
//       });
//     } catch (error) {
//       console.error("❌ Error submitting donation:", error);
//       alert("Something went wrong. Please try again.");
//     }
//   };

//   return (
//     <div className="donate-page">
//       <h2>Donate to Navveer Foundation</h2>
//       <div className="bank-details">
//         <p><strong>Account Name:</strong> Navveer Foundation</p>
//         <p><strong>Bank Name:</strong> Bandhan Bank, Kalkaji Branch</p>
//         <p><strong>Account No:</strong> 20100048060316</p>
//         <p><strong>IFSC Code:</strong> BDBL0001215</p>
//       </div>

//       <form className="donate-form" onSubmit={handleSubmit}>
//         <input
//           type="text"
//           placeholder="Your Name"
//           value={formData.name}
//           required
//           onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//         />
//         <input
//           type="email"
//           placeholder="Your Email"
//           value={formData.email}
//           required
//           onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//         />
//         <input
//           type="tel"
//           placeholder="Your Phone"
//           value={formData.phone}
//           required
//           onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//         />
//         <input
//           type="text"
//           placeholder="Transaction ID"
//           value={formData.transactionId}
//           required
//           onChange={(e) => setFormData({ ...formData, transactionId: e.target.value })}
//         />
//         <label>Upload Payment Screenshot:</label>
//         <input
//           type="file"
//           accept="image/*"
//           onChange={(e) => setFormData({ ...formData, screenshot: e.target.files[0] })}
//           required
//         />
//         <button type="submit">Submit</button>
//       </form>
//     </div>
//   );
// };

// export default DonatePage;




import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import Swal from "sweetalert2";
import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";
import "./DonatePage.css";

const DonatePage = () => {
  const [amount, setAmount] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    transactionId: "",
    screenshot: null,
  });

  const upiID = "9625052063@upi";
  const name = "Navveer Foundation";
  const upiLink = `upi://pay?pa=${upiID}&pn=${encodeURIComponent(name)}&am=${amount}&cu=INR`;

  const handleShowQR = (e) => {
    e.preventDefault();
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      Swal.fire("Invalid amount", "Please enter a valid donation amount", "warning");
      return;
    }
    setShowQR(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "donations"), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        transactionId: formData.transactionId,
        screenshot: formData.screenshot?.name || null, // optional
        amount,
        timestamp: new Date(),
      });

      Swal.fire("Thank You!", "Your donation has been recorded. We'll contact you soon.", "success");

      // Reset
      setFormData({
        name: "",
        email: "",
        phone: "",
        transactionId: "",
        screenshot: null,
      });
      setAmount("");
      setShowQR(false);
    } catch (error) {
      console.error("Error saving donation:", error);
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };

  return (
    <div className="donate-page">
      <h2>Donate to Navveer Foundation</h2>

      <div className="bank-details">
        <p><strong>UPI ID:</strong> {upiID}</p>
        <p><strong>Bank Name:</strong> Bandhan Bank, Kalkaji Branch</p>
        <p><strong>Account No:</strong> 20100048060316</p>
        <p><strong>IFSC Code:</strong> BDBL0001215</p>
      </div>

      <form className="donate-form" onSubmit={handleShowQR}>
        <label>Enter Donation Amount (INR)</label>
        <input
          type="number"
          placeholder="₹ Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          required
        />
        <button type="submit">Generate QR Code</button>
      </form>

      {showQR && (
        <div className="qr-section">
          <h3>Scan the QR Code with your UPI app</h3>
          <QRCodeCanvas value={upiLink} size={200} />
          <p>{upiLink}</p>
        </div>
      )}

      {showQR && (
        <form className="donate-form" onSubmit={handleSubmit}>
          <h3>Confirm Your Payment</h3>
          <input
            type="text"
            placeholder="Your Name"
            value={formData.name}
            required
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <input
            type="email"
            placeholder="Your Email"
            value={formData.email}
            required
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          <input
            type="tel"
            placeholder="Your Phone"
            value={formData.phone}
            required
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
          <input
            type="text"
            placeholder="Transaction ID"
            value={formData.transactionId}
            required
            onChange={(e) => setFormData({ ...formData, transactionId: e.target.value })}
          />
          <label>Upload Payment Screenshot (optional)</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFormData({ ...formData, screenshot: e.target.files[0] })}
          />
          <button type="submit">Submit Donation</button>
        </form>
      )}
    </div>
  );
};

export default DonatePage;
